import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <details>
      <summary><b>Using with Astro's view transitions (ClientRouter)</b></summary>
      <p>{`If you've opted in to Astro's `}<inlineCode parentName="p">{`<ClientRouter>`}</inlineCode>{` component for client-side navigation, you'll need to add an initialization guard to prevent PostHog from running multiple times during page transitions.`}</p>
      <p>{`Update your `}<inlineCode parentName="p">{`posthog.astro`}</inlineCode>{` file to wrap the snippet with a check:`}</p>
      <pre><code parentName="pre" {...{
          "className": "language-astro",
          "metastring": "file=posthog.astro",
          "file": "posthog.astro"
        }}>{`---
// src/components/posthog.astro
---
<script is:inline>
  if (!window.__posthog_initialized) {
    window.__posthog_initialized = true;
    
    !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="capture identify alias people.set people.set_once set_config register register_once unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled onFeatureFlags getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group updateEarlyAccessFeatureEnrollment getEarlyAccessFeatures getActiveMatchingSurveys getSurveys getNextSurveyStep onSessionId".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
    
    posthog.init('<ph_project_api_key>', {
      api_host: '<ph_client_api_host>',
      defaults: '<ph_posthog_js_defaults>',
      capture_pageview: 'history_change'
    })
  }
</script>
`}</code></pre>
      <p>{`Without this guard, `}<inlineCode parentName="p">{`ClientRouter`}</inlineCode>{`'s soft navigation can re-execute the inline script during page transitions, causing a stack overflow error. The `}<inlineCode parentName="p">{`capture_pageview: 'history_change'`}</inlineCode>{` option ensures pageviews are tracked automatically as users navigate.`}</p>
    </details>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      